"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MerkleTree = void 0;

var buffer_reverse_1 = __importDefault(require("buffer-reverse"));

var sha256_1 = __importDefault(require("crypto-js/sha256"));

var Base_1 = __importDefault(require("./Base"));

var treeify_1 = __importDefault(require("treeify"));
/**
 * Class reprensenting a Merkle Tree
 * @namespace MerkleTree
 */


var MerkleTree = /*#__PURE__*/function (_Base_1$default) {
  _inherits(MerkleTree, _Base_1$default);

  var _super = _createSuper(MerkleTree);

  /**
   * @desc Constructs a Merkle Tree.
   * All nodes and leaves are stored as Buffers.
   * Lonely leaf nodes are promoted to the next level up without being hashed again.
   * @param {Buffer[]} leaves - Array of hashed leaves. Each leaf must be a Buffer.
   * @param {Function} hashFunction - Hash function to use for hashing leaves and nodes
   * @param {Object} options - Additional options
   * @example
   *```js
   *const MerkleTree = require('merkletreejs')
   *const crypto = require('crypto')
   *
   *function sha256(data) {
   *  // returns Buffer
   *  return crypto.createHash('sha256').update(data).digest()
   *}
   *
   *const leaves = ['a', 'b', 'c'].map(value => keccak(value))
   *
   *const tree = new MerkleTree(leaves, sha256)
   *```
   */
  function MerkleTree(leaves) {
    var _this;

    var hashFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sha256_1.default;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, MerkleTree);

    _this = _super.call(this);
    _this.duplicateOdd = false;
    _this.hashLeaves = false;
    _this.isBitcoinTree = false;
    _this.leaves = [];
    _this.layers = [];
    _this.sortLeaves = false;
    _this.sortPairs = false;
    _this.sort = false;
    _this.fillDefaultHash = null;
    _this.isBitcoinTree = !!options.isBitcoinTree;
    _this.hashLeaves = !!options.hashLeaves;
    _this.sortLeaves = !!options.sortLeaves;
    _this.sortPairs = !!options.sortPairs;

    if (options.fillDefaultHash) {
      if (typeof options.fillDefaultHash === 'function') {
        _this.fillDefaultHash = options.fillDefaultHash;
      } else if (Buffer.isBuffer(options.fillDefaultHash) || typeof options.fillDefaultHash === 'string') {
        _this.fillDefaultHash = function (idx, hashFn) {
          return options.fillDefaultHash;
        };
      } else {
        throw new Error('method "fillDefaultHash" must be a function, Buffer, or string');
      }
    }

    _this.sort = !!options.sort;

    if (_this.sort) {
      _this.sortLeaves = true;
      _this.sortPairs = true;
    }

    _this.duplicateOdd = !!options.duplicateOdd;
    _this.hashFn = _this.bufferifyFn(hashFn);

    _this.processLeaves(leaves);

    return _this;
  }

  _createClass(MerkleTree, [{
    key: "processLeaves",
    value: function processLeaves(leaves) {
      if (this.hashLeaves) {
        leaves = leaves.map(this.hashFn);
      }

      this.leaves = leaves.map(this.bufferify);

      if (this.sortLeaves) {
        this.leaves = this.leaves.sort(Buffer.compare);
      }

      if (this.fillDefaultHash) {
        for (var i = 0; i < Math.pow(2, Math.ceil(Math.log2(this.leaves.length))); i++) {
          if (i >= this.leaves.length) {
            this.leaves.push(this.bufferify(this.fillDefaultHash(i, this.hashFn)));
          }
        }
      }

      this.layers = [this.leaves];

      this._createHashes(this.leaves);
    }
  }, {
    key: "_createHashes",
    value: function _createHashes(nodes) {
      while (nodes.length > 1) {
        var layerIndex = this.layers.length;
        this.layers.push([]);

        for (var i = 0; i < nodes.length; i += 2) {
          if (i + 1 === nodes.length) {
            if (nodes.length % 2 === 1) {
              var _data = nodes[nodes.length - 1];
              var _hash = _data; // is bitcoin tree

              if (this.isBitcoinTree) {
                // Bitcoin method of duplicating the odd ending nodes
                _data = Buffer.concat([buffer_reverse_1.default(_data), buffer_reverse_1.default(_data)]);
                _hash = this.hashFn(_data);
                _hash = buffer_reverse_1.default(this.hashFn(_hash));
                this.layers[layerIndex].push(_hash);
                continue;
              } else {
                if (this.duplicateOdd) {// continue with creating layer
                } else {
                  // push copy of hash and continue iteration
                  this.layers[layerIndex].push(nodes[i]);
                  continue;
                }
              }
            }
          }

          var left = nodes[i];
          var right = i + 1 === nodes.length ? left : nodes[i + 1];
          var data = null;
          var combined = null;

          if (this.isBitcoinTree) {
            combined = [buffer_reverse_1.default(left), buffer_reverse_1.default(right)];
          } else {
            combined = [left, right];
          }

          if (this.sortPairs) {
            combined.sort(Buffer.compare);
          }

          data = Buffer.concat(combined);
          var hash = this.hashFn(data); // double hash if bitcoin tree

          if (this.isBitcoinTree) {
            hash = buffer_reverse_1.default(this.hashFn(hash));
          }

          this.layers[layerIndex].push(hash);
        }

        nodes = this.layers[layerIndex];
      }
    }
    /**
     * addLeaf
     * @desc Adds a leaf to the tree and re-calculates layers.
     * @param {String|Buffer} - Leaf
     * @param {Boolean} - Set to true if the leaf should be hashed before being added to tree.
     * @example
     *```js
     *tree.addLeaf(newLeaf)
     *```
     */

  }, {
    key: "addLeaf",
    value: function addLeaf(leaf) {
      var shouldHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (shouldHash) {
        leaf = this.hashFn(leaf);
      }

      this.processLeaves(this.leaves.concat(leaf));
    }
    /**
     * addLeaves
     * @desc Adds multiple leaves to the tree and re-calculates layers.
     * @param {String[]|Buffer[]} - Array of leaves
     * @param {Boolean} - Set to true if the leaves should be hashed before being added to tree.
     * @example
     *```js
     *tree.addLeaves(newLeaves)
     *```
     */

  }, {
    key: "addLeaves",
    value: function addLeaves(leaves) {
      var shouldHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (shouldHash) {
        leaves = leaves.map(this.hashFn);
      }

      this.processLeaves(this.leaves.concat(leaves));
    }
    /**
     * getLeaves
     * @desc Returns array of leaves of Merkle Tree.
     * @return {Buffer[]}
     * @example
     *```js
     *const leaves = tree.getLeaves()
     *```
     */

  }, {
    key: "getLeaves",
    value: function getLeaves(values) {
      var _this2 = this;

      if (Array.isArray(values)) {
        if (this.hashLeaves) {
          values = values.map(this.hashFn);

          if (this.sortLeaves) {
            values = values.sort(Buffer.compare);
          }
        }

        return this.leaves.filter(function (leaf) {
          return _this2._bufferIndexOf(values, leaf) !== -1;
        });
      }

      return this.leaves;
    }
    /**
     * getLeaf
     * @desc Returns the leaf at the given index.
     * @param {Number} - Index number
     * @return {Buffer}
     * @example
     *```js
     *const leaf = tree.getLeaf(1)
     *```
     */

  }, {
    key: "getLeaf",
    value: function getLeaf(index) {
      if (index < 0 || index > this.leaves.length - 1) {
        return Buffer.from([]);
      }

      return this.leaves[index];
    }
    /**
     * getLeafIndex
     * @desc Returns the index of the given leaf, or -1 if the leaf is not found.
     * @param {String|Buffer} - Target leaf
     * @return {number}
     * @example
     *```js
     *const leaf = Buffer.from('abc')
     *const index = tree.getLeafIndex(leaf)
     *```
     */

  }, {
    key: "getLeafIndex",
    value: function getLeafIndex(target) {
      target = this.bufferify(target);
      var leaves = this.getLeaves();

      for (var i = 0; i < leaves.length; i++) {
        var leaf = leaves[i];

        if (leaf.equals(target)) {
          return i;
        }
      }

      return -1;
    }
    /**
     * getLeafCount
     * @desc Returns the total number of leaves.
     * @return {number}
     * @example
     *```js
     *const count = tree.getLeafCount()
     *```
     */

  }, {
    key: "getLeafCount",
    value: function getLeafCount() {
      return this.leaves.length;
    }
    /**
     * getHexLeaves
     * @desc Returns array of leaves of Merkle Tree as hex strings.
     * @return {String[]}
     * @example
     *```js
     *const leaves = tree.getHexLeaves()
     *```
     */

  }, {
    key: "getHexLeaves",
    value: function getHexLeaves() {
      var _this3 = this;

      return this.leaves.map(function (leaf) {
        return _this3.bufferToHex(leaf);
      });
    }
    /**
     * marshalLeaves
     * @desc Returns array of leaves of Merkle Tree as a JSON string.
     * @param {String[]|Buffer[]} - Merkle tree leaves
     * @return {String} - List of leaves as JSON string
     * @example
     *```js
     *const jsonStr = MerkleTree.marshalLeaves(leaves)
     *```
     */

  }, {
    key: "getLayers",
    value:
    /**
     * getLayers
     * @desc Returns multi-dimensional array of all layers of Merkle Tree, including leaves and root.
     * @return {Buffer[]}
     * @example
     *```js
     *const layers = tree.getLayers()
     *```
     */
    function getLayers() {
      return this.layers;
    }
    /**
     * getHexLayers
     * @desc Returns multi-dimensional array of all layers of Merkle Tree, including leaves and root as hex strings.
     * @return {String[]}
     * @example
     *```js
     *const layers = tree.getHexLayers()
     *```
     */

  }, {
    key: "getHexLayers",
    value: function getHexLayers() {
      var _this4 = this;

      return this.layers.reduce(function (acc, item) {
        if (Array.isArray(item)) {
          acc.push(item.map(function (layer) {
            return _this4.bufferToHex(layer);
          }));
        } else {
          acc.push(item);
        }

        return acc;
      }, []);
    }
    /**
     * getLayersFlat
     * @desc Returns single flat array of all layers of Merkle Tree, including leaves and root.
     * @return {Buffer[]}
     * @example
     *```js
     *const layers = tree.getLayersFlat()
     *```
     */

  }, {
    key: "getLayersFlat",
    value: function getLayersFlat() {
      var layers = this.layers.reduce(function (acc, item) {
        if (Array.isArray(item)) {
          acc.unshift.apply(acc, _toConsumableArray(item));
        } else {
          acc.unshift(item);
        }

        return acc;
      }, []);
      layers.unshift(Buffer.from([0]));
      return layers;
    }
    /**
     * getHexLayersFlat
     * @desc Returns single flat array of all layers of Merkle Tree, including leaves and root as hex string.
     * @return {String[]}
     * @example
     *```js
     *const layers = tree.getHexLayersFlat()
     *```
     */

  }, {
    key: "getHexLayersFlat",
    value: function getHexLayersFlat() {
      var _this5 = this;

      return this.getLayersFlat().map(function (layer) {
        return _this5.bufferToHex(layer);
      });
    }
    /**
     * getLayerCount
     * @desc Returns the total number of layers.
     * @return {number}
     * @example
     *```js
     *const count = tree.getLayerCount()
     *```
     */

  }, {
    key: "getLayerCount",
    value: function getLayerCount() {
      return this.getLayers().length;
    }
    /**
     * getRoot
     * @desc Returns the Merkle root hash as a Buffer.
     * @return {Buffer}
     * @example
     *```js
     *const root = tree.getRoot()
     *```
     */

  }, {
    key: "getRoot",
    value: function getRoot() {
      if (this.layers.length === 0) {
        return Buffer.from([]);
      }

      return this.layers[this.layers.length - 1][0] || Buffer.from([]);
    }
    /**
     * getHexRoot
     * @desc Returns the Merkle root hash as a hex string.
     * @return {String}
     * @example
     *```js
     *const root = tree.getHexRoot()
     *```
     */

  }, {
    key: "getHexRoot",
    value: function getHexRoot() {
      return this.bufferToHex(this.getRoot());
    }
    /**
     * getProof
     * @desc Returns the proof for a target leaf.
     * @param {Buffer} leaf - Target leaf
     * @param {Number} [index] - Target leaf index in leaves array.
     * Use if there are leaves containing duplicate data in order to distinguish it.
     * @return {Object[]} - Array of objects containing a position property of type string
     * with values of 'left' or 'right' and a data property of type Buffer.
     * @example
     * ```js
     *const proof = tree.getProof(leaves[2])
     *```
     *
     * @example
     *```js
     *const leaves = ['a', 'b', 'a'].map(value => keccak(value))
     *const tree = new MerkleTree(leaves, keccak)
     *const proof = tree.getProof(leaves[2], 2)
     *```
     */

  }, {
    key: "getProof",
    value: function getProof(leaf, index) {
      if (typeof leaf === 'undefined') {
        throw new Error('leaf is required');
      }

      leaf = this.bufferify(leaf);
      var proof = [];

      if (!Number.isInteger(index)) {
        index = -1;

        for (var i = 0; i < this.leaves.length; i++) {
          if (Buffer.compare(leaf, this.leaves[i]) === 0) {
            index = i;
          }
        }
      }

      if (index <= -1) {
        return [];
      }

      for (var _i = 0; _i < this.layers.length; _i++) {
        var layer = this.layers[_i];
        var isRightNode = index % 2;
        var pairIndex = isRightNode ? index - 1 : this.isBitcoinTree && index === layer.length - 1 && _i < this.layers.length - 1 // Proof Generation for Bitcoin Trees
        ? index // Proof Generation for Non-Bitcoin Trees
        : index + 1;

        if (pairIndex < layer.length) {
          proof.push({
            position: isRightNode ? 'left' : 'right',
            data: layer[pairIndex]
          });
        } // set index to parent index


        index = index / 2 | 0;
      }

      return proof;
    }
    /**
     * getHexProof
     * @desc Returns the proof for a target leaf as hex strings.
     * @param {Buffer} leaf - Target leaf
     * @param {Number} [index] - Target leaf index in leaves array.
     * Use if there are leaves containing duplicate data in order to distinguish it.
     * @return {String[]} - Proof array as hex strings.
     * @example
     * ```js
     *const proof = tree.getHexProof(leaves[2])
     *```
     */

  }, {
    key: "getHexProof",
    value: function getHexProof(leaf, index) {
      var _this6 = this;

      return this.getProof(leaf, index).map(function (item) {
        return _this6.bufferToHex(item.data);
      });
    }
    /**
    * getPositionalHexProof
    * @desc Returns the proof for a target leaf as hex strings and the position in binary (left == 0).
    * @param {Buffer} leaf - Target leaf
    * @param {Number} [index] - Target leaf index in leaves array.
    * Use if there are leaves containing duplicate data in order to distinguish it.
    * @return {(string | number)[][]} - Proof array as hex strings. position at index 0
    * @example
    * ```js
    *const proof = tree.getPositionalHexProof(leaves[2])
    *```
    */

  }, {
    key: "getPositionalHexProof",
    value: function getPositionalHexProof(leaf, index) {
      var _this7 = this;

      return this.getProof(leaf, index).map(function (item) {
        return [item.position === 'left' ? 0 : 1, _this7.bufferToHex(item.data)];
      });
    }
    /**
     * marshalProof
     * @desc Returns proof array as JSON string.
     * @param {String[]|Object[]} proof - Merkle tree proof array
     * @return {String} - Proof array as JSON string.
     * @example
     * ```js
     *const jsonStr = MerkleTree.marshalProof(proof)
     *```
     */

  }, {
    key: "getProofIndices",
    value:
    /**
     * getProofIndices
     * @desc Returns the proof indices for given tree indices.
     * @param {Number[]} treeIndices - Tree indices
     * @param {Number} depth - Tree depth; number of layers.
     * @return {Number[]} - Proof indices
     * @example
     * ```js
     *const proofIndices = tree.getProofIndices([2,5,6], 4)
     *console.log(proofIndices) // [ 23, 20, 19, 8, 3 ]
     *```
     */
    function getProofIndices(treeIndices, depth) {
      var leafCount = Math.pow(2, depth);
      var maximalIndices = new Set();

      var _iterator = _createForOfIteratorHelper(treeIndices),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var index = _step.value;
          var x = leafCount + index;

          while (x > 1) {
            maximalIndices.add(x ^ 1);
            x = x / 2 | 0;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var a = treeIndices.map(function (index) {
        return leafCount + index;
      });
      var b = Array.from(maximalIndices).sort(function (a, b) {
        return a - b;
      }).reverse();
      maximalIndices = a.concat(b);
      var redundantIndices = new Set();
      var proof = [];

      var _iterator2 = _createForOfIteratorHelper(maximalIndices),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _index = _step2.value;

          if (!redundantIndices.has(_index)) {
            proof.push(_index);

            while (_index > 1) {
              redundantIndices.add(_index);
              if (!redundantIndices.has(_index ^ 1)) break;
              _index = _index / 2 | 0;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return proof.filter(function (index) {
        return !treeIndices.includes(index - leafCount);
      });
    }
  }, {
    key: "getProofIndicesForUnevenTree",
    value: function getProofIndicesForUnevenTree(sortedLeafIndices, leavesCount) {
      var depth = Math.ceil(Math.log2(leavesCount));
      var unevenLayers = [];

      for (var index = 0; index < depth; index++) {
        var unevenLayer = leavesCount % 2 !== 0;

        if (unevenLayer) {
          unevenLayers.push({
            index: index,
            leavesCount: leavesCount
          });
        }

        leavesCount = Math.ceil(leavesCount / 2);
      }

      var proofIndices = [];
      var layerNodes = sortedLeafIndices;

      var _loop = function _loop(layerIndex) {
        var siblingIndices = layerNodes.map(function (index) {
          if (index % 2 === 0) {
            return index + 1;
          }

          return index - 1;
        });
        var proofNodeIndices = siblingIndices.filter(function (index) {
          return !layerNodes.includes(index);
        });
        var unevenLayer = unevenLayers.find(function (_ref) {
          var index = _ref.index;
          return index === layerIndex;
        });

        if (unevenLayer && layerNodes.includes(unevenLayer.leavesCount - 1)) {
          proofNodeIndices = proofNodeIndices.slice(0, -1);
        }

        proofIndices.push(proofNodeIndices);
        layerNodes = _toConsumableArray(new Set(layerNodes.map(function (index) {
          if (index % 2 === 0) {
            return index / 2;
          }

          if (index % 2 === 0) {
            return (index + 1) / 2;
          }

          return (index - 1) / 2;
        })));
      };

      for (var layerIndex = 0; layerIndex < depth; layerIndex++) {
        _loop(layerIndex);
      }

      return proofIndices;
    }
    /**
     * getMultiProof
     * @desc Returns the multiproof for given tree indices.
     * @param {Number[]} indices - Tree indices.
     * @return {Buffer[]} - Multiproofs
     * @example
     * ```js
     *const indices = [2, 5, 6]
     *const proof = tree.getMultiProof(indices)
     *```
     */

  }, {
    key: "getMultiProof",
    value: function getMultiProof(tree, indices) {
      var _this8 = this;

      if (!indices) {
        indices = tree;
        tree = this.getLayersFlat();
      }

      var isUneven = this.isUnevenTree();

      if (isUneven) {
        if (indices.every(Number.isInteger)) {
          return this.getMultiProofForUnevenTree(indices);
        }
      }

      if (!indices.every(Number.isInteger)) {
        var els = indices;

        if (this.sortPairs) {
          els = els.sort(Buffer.compare);
        }

        var ids = els.map(function (el) {
          return _this8._bufferIndexOf(_this8.leaves, el);
        }).sort(function (a, b) {
          return a === b ? 0 : a > b ? 1 : -1;
        });

        if (!ids.every(function (idx) {
          return idx !== -1;
        })) {
          throw new Error('Element does not exist in Merkle tree');
        }

        var hashes = [];
        var proof = [];
        var nextIds = [];

        for (var i = 0; i < this.layers.length; i++) {
          var layer = this.layers[i];

          for (var j = 0; j < ids.length; j++) {
            var idx = ids[j];

            var pairElement = this._getPairNode(layer, idx);

            hashes.push(layer[idx]);

            if (pairElement) {
              proof.push(pairElement);
            }

            nextIds.push(idx / 2 | 0);
          }

          ids = nextIds.filter(function (value, i, self) {
            return self.indexOf(value) === i;
          });
          nextIds = [];
        }

        return proof.filter(function (value) {
          return !hashes.includes(value);
        });
      }

      return this.getProofIndices(indices, this._log2(tree.length / 2 | 0)).map(function (index) {
        return tree[index];
      });
    }
  }, {
    key: "getMultiProofForUnevenTree",
    value: function getMultiProofForUnevenTree(tree, indices) {
      if (!indices) {
        indices = tree;
        tree = this.getLayers();
      }

      var proofHashes = [];
      var currentLayerIndices = indices;

      var _iterator3 = _createForOfIteratorHelper(tree),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var treeLayer = _step3.value;
          var siblings = [];

          var _iterator4 = _createForOfIteratorHelper(currentLayerIndices),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var index = _step4.value;

              if (index % 2 === 0) {
                var _idx = index + 1;

                if (!currentLayerIndices.includes(_idx)) {
                  if (treeLayer[_idx]) {
                    siblings.push(treeLayer[_idx]);
                    continue;
                  }
                }
              }

              var idx = index - 1;

              if (!currentLayerIndices.includes(idx)) {
                if (treeLayer[idx]) {
                  siblings.push(treeLayer[idx]);
                  continue;
                }
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          proofHashes = proofHashes.concat(siblings);
          var uniqueIndices = new Set();

          var _iterator5 = _createForOfIteratorHelper(currentLayerIndices),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _index2 = _step5.value;

              if (_index2 % 2 === 0) {
                uniqueIndices.add(_index2 / 2);
                continue;
              }

              if (_index2 % 2 === 0) {
                uniqueIndices.add((_index2 + 1) / 2);
                continue;
              }

              uniqueIndices.add((_index2 - 1) / 2);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          currentLayerIndices = Array.from(uniqueIndices);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return proofHashes;
    }
    /**
     * getHexMultiProof
     * @desc Returns the multiproof for given tree indices as hex strings.
     * @param {Number[]} indices - Tree indices.
     * @return {String[]} - Multiproofs as hex strings.
     * @example
     * ```js
     *const indices = [2, 5, 6]
     *const proof = tree.getHexMultiProof(indices)
     *```
     */

  }, {
    key: "getHexMultiProof",
    value: function getHexMultiProof(tree, indices) {
      var _this9 = this;

      return this.getMultiProof(tree, indices).map(function (x) {
        return _this9.bufferToHex(x);
      });
    }
    /**
     * getProofFlags
     * @desc Returns list of booleans where proofs should be used instead of hashing.
     * Proof flags are used in the Solidity multiproof verifiers.
     * @param {Number[]|Buffer[]} leaves
     * @param {Buffer[]} proofs
     * @return {Boolean[]} - Boolean flags
     * @example
     * ```js
     *const indices = [2, 5, 6]
     *const proof = tree.getMultiProof(indices)
     *const proofFlags = tree.getProofFlags(leaves, proof)
     *```
     */

  }, {
    key: "getProofFlags",
    value: function getProofFlags(leaves, proofs) {
      var _this10 = this;

      if (!Array.isArray(leaves) || leaves.length <= 0) {
        throw new Error('Invalid Inputs!');
      }

      var ids;

      if (leaves.every(Number.isInteger)) {
        ids = leaves.sort(function (a, b) {
          return a === b ? 0 : a > b ? 1 : -1;
        }); // Indices where passed
      } else {
        ids = leaves.map(function (el) {
          return _this10._bufferIndexOf(_this10.leaves, el);
        }).sort(function (a, b) {
          return a === b ? 0 : a > b ? 1 : -1;
        });
      }

      if (!ids.every(function (idx) {
        return idx !== -1;
      })) {
        throw new Error('Element does not exist in Merkle tree');
      }

      var _proofs = proofs.map(function (item) {
        return _this10.bufferify(item);
      });

      var tested = [];
      var flags = [];

      var _loop2 = function _loop2(index) {
        var layer = _this10.layers[index];
        ids = ids.reduce(function (ids, idx) {
          var skipped = tested.includes(layer[idx]);

          if (!skipped) {
            var pairElement = _this10._getPairNode(layer, idx);

            var proofUsed = _proofs.includes(layer[idx]) || _proofs.includes(pairElement);

            pairElement && flags.push(!proofUsed);
            tested.push(layer[idx]);
            tested.push(pairElement);
          }

          ids.push(idx / 2 | 0);
          return ids;
        }, []);
      };

      for (var index = 0; index < this.layers.length; index++) {
        _loop2(index);
      }

      return flags;
    }
    /**
     * verify
     * @desc Returns true if the proof path (array of hashes) can connect the target node
     * to the Merkle root.
     * @param {Object[]} proof - Array of proof objects that should connect
     * target node to Merkle root.
     * @param {Buffer} targetNode - Target node Buffer
     * @param {Buffer} root - Merkle root Buffer
     * @return {Boolean}
     * @example
     *```js
     *const root = tree.getRoot()
     *const proof = tree.getProof(leaves[2])
     *const verified = tree.verify(proof, leaves[2], root)
     *```
     */

  }, {
    key: "verify",
    value: function verify(proof, targetNode, root) {
      var hash = this.bufferify(targetNode);
      root = this.bufferify(root);

      if (!Array.isArray(proof) || !targetNode || !root) {
        return false;
      }

      for (var i = 0; i < proof.length; i++) {
        var node = proof[i];
        var data = null;
        var isLeftNode = null; // case for when proof is hex values only

        if (typeof node === 'string') {
          data = this.bufferify(node);
          isLeftNode = true;
        } else if (Array.isArray(node)) {
          isLeftNode = node[0] === 0;
          data = this.bufferify(node[1]);
        } else if (Buffer.isBuffer(node)) {
          data = node;
          isLeftNode = true;
        } else if (node instanceof Object) {
          data = this.bufferify(node.data);
          isLeftNode = node.position === 'left';
        } else {
          throw new Error('Expected node to be of type string or object');
        }

        var buffers = [];

        if (this.isBitcoinTree) {
          buffers.push(buffer_reverse_1.default(hash));
          buffers[isLeftNode ? 'unshift' : 'push'](buffer_reverse_1.default(data));
          hash = this.hashFn(Buffer.concat(buffers));
          hash = buffer_reverse_1.default(this.hashFn(hash));
        } else {
          if (this.sortPairs) {
            if (Buffer.compare(hash, data) === -1) {
              buffers.push(hash, data);
              hash = this.hashFn(Buffer.concat(buffers));
            } else {
              buffers.push(data, hash);
              hash = this.hashFn(Buffer.concat(buffers));
            }
          } else {
            buffers.push(hash);
            buffers[isLeftNode ? 'unshift' : 'push'](data);
            hash = this.hashFn(Buffer.concat(buffers));
          }
        }
      }

      return Buffer.compare(hash, root) === 0;
    }
    /**
     * verifyMultiProof
     * @desc Returns true if the multiproofs can connect the leaves to the Merkle root.
     * @param {Buffer} root - Merkle tree root
     * @param {Number[]} proofIndices - Leave indices for proof
     * @param {Buffer[]} proofLeaves - Leaf values at indices for proof
     * @param {Number} leavesCount - Count of original leaves
     * @param {Buffer[]} proof - Multiproofs given indices
     * @return {Boolean}
     * @example
     *```js
     *const leaves = tree.getLeaves()
     *const root = tree.getRoot()
     *const treeFlat = tree.getLayersFlat()
     *const leavesCount = leaves.length
     *const proofIndices = [2, 5, 6]
     *const proofLeaves = proofIndices.map(i => leaves[i])
     *const proof = tree.getMultiProof(treeFlat, indices)
     *const verified = tree.verifyMultiProof(root, proofIndices, proofLeaves, leavesCount, proof)
     *```
     */

  }, {
    key: "verifyMultiProof",
    value: function verifyMultiProof(root, proofIndices, proofLeaves, leavesCount, proof) {
      var _this11 = this;

      var isUneven = this.isUnevenTree();

      if (isUneven) {
        // TODO: combine these functions and simplify
        return this.verifyMultiProofForUnevenTree(root, proofIndices, proofLeaves, leavesCount, proof);
      }

      var depth = Math.ceil(Math.log2(leavesCount));
      root = this.bufferify(root);
      proofLeaves = proofLeaves.map(function (leaf) {
        return _this11.bufferify(leaf);
      });
      proof = proof.map(function (leaf) {
        return _this11.bufferify(leaf);
      });
      var tree = {};

      var _iterator6 = _createForOfIteratorHelper(this._zip(proofIndices, proofLeaves)),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref6 = _step6.value;

          var _ref3 = _slicedToArray(_ref6, 2);

          var _index3 = _ref3[0];
          var leaf = _ref3[1];
          tree[Math.pow(2, depth) + _index3] = leaf;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      var _iterator7 = _createForOfIteratorHelper(this._zip(this.getProofIndices(proofIndices, depth), proof)),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _ref7 = _step7.value;

          var _ref5 = _slicedToArray(_ref7, 2);

          var _index4 = _ref5[0];
          var proofitem = _ref5[1];
          tree[_index4] = proofitem;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var indexqueue = Object.keys(tree).map(function (value) {
        return +value;
      }).sort(function (a, b) {
        return a - b;
      });
      indexqueue = indexqueue.slice(0, indexqueue.length - 1);
      var i = 0;

      while (i < indexqueue.length) {
        var index = indexqueue[i];

        if (index >= 2 && {}.hasOwnProperty.call(tree, index ^ 1)) {
          var pair = [tree[index - index % 2], tree[index - index % 2 + 1]];

          if (this.sortPairs) {
            pair = pair.sort(Buffer.compare);
          }

          var hash = pair[1] ? this.hashFn(Buffer.concat(pair)) : pair[0];
          tree[index / 2 | 0] = hash;
          indexqueue.push(index / 2 | 0);
        }

        i += 1;
      }

      return !proofIndices.length || {}.hasOwnProperty.call(tree, 1) && tree[1].equals(root);
    }
  }, {
    key: "verifyMultiProofWithFlags",
    value: function verifyMultiProofWithFlags(root, leaves, proofs, proofFlag) {
      root = this.bufferify(root);
      leaves = leaves.map(this.bufferify);
      proofs = proofs.map(this.bufferify);
      var leavesLen = leaves.length;
      var totalHashes = proofFlag.length;
      var hashes = [];
      var leafPos = 0;
      var hashPos = 0;
      var proofPos = 0;

      for (var i = 0; i < totalHashes; i++) {
        var bufA = proofFlag[i] ? leafPos < leavesLen ? leaves[leafPos++] : hashes[hashPos++] : proofs[proofPos++];
        var bufB = leafPos < leavesLen ? leaves[leafPos++] : hashes[hashPos++];
        var buffers = [bufA, bufB].sort(Buffer.compare);
        hashes[i] = this.hashFn(Buffer.concat(buffers));
      }

      return Buffer.compare(hashes[totalHashes - 1], root) === 0;
    }
  }, {
    key: "verifyMultiProofForUnevenTree",
    value: function verifyMultiProofForUnevenTree(root, indices, leaves, leavesCount, proof) {
      var _this12 = this;

      root = this.bufferify(root);
      leaves = leaves.map(function (leaf) {
        return _this12.bufferify(leaf);
      });
      proof = proof.map(function (leaf) {
        return _this12.bufferify(leaf);
      });
      var computedRoot = this.calculateRootForUnevenTree(indices, leaves, leavesCount, proof);
      return root.equals(computedRoot);
    }
    /**
     * getDepth
     * @desc Returns the tree depth (number of layers)
     * @return {Number}
     * @example
     *```js
     *const depth = tree.getDepth()
     *```
     */

  }, {
    key: "getDepth",
    value: function getDepth() {
      return this.getLayers().length - 1;
    }
    /**
     * getLayersAsObject
     * @desc Returns the layers as nested objects instead of an array.
     * @example
     *```js
     *const layersObj = tree.getLayersAsObject()
     *```
     */

  }, {
    key: "getLayersAsObject",
    value: function getLayersAsObject() {
      var _this13 = this;

      var layers = this.getLayers().map(function (layer) {
        return layer.map(function (value) {
          return _this13.bufferToHex(value, false);
        });
      });
      var objs = [];

      for (var i = 0; i < layers.length; i++) {
        var arr = [];

        for (var j = 0; j < layers[i].length; j++) {
          var obj = _defineProperty({}, layers[i][j], null);

          if (objs.length) {
            obj[layers[i][j]] = {};
            var a = objs.shift();
            var akey = Object.keys(a)[0];
            obj[layers[i][j]][akey] = a[akey];

            if (objs.length) {
              var b = objs.shift();
              var bkey = Object.keys(b)[0];
              obj[layers[i][j]][bkey] = b[bkey];
            }
          }

          arr.push(obj);
        }

        objs.push.apply(objs, arr);
      }

      return objs[0];
    }
    /**
     * verify
     * @desc Returns true if the proof path (array of hashes) can connect the target node
     * to the Merkle root.
     * @param {Object[]} proof - Array of proof objects that should connect
     * target node to Merkle root.
     * @param {Buffer} targetNode - Target node Buffer
     * @param {Buffer} root - Merkle root Buffer
     * @param {Function} hashFunction - Hash function for hashing leaves and nodes
     * @param {Object} options - Additional options
     * @return {Boolean}
     * @example
     *```js
     *const verified = MerkleTree.verify(proof, leaf, root, sha256, options)
     *```
     */

  }, {
    key: "resetTree",
    value:
    /**
     * resetTree
     * @desc Resets the tree by clearing the leaves and layers.
     * @example
     *```js
     *tree.resetTree()
     *```
     */
    function resetTree() {
      this.leaves = [];
      this.layers = [];
    }
    /**
     * getPairNode
     * @desc Returns the node at the index for given layer.
     * @param {Buffer[]} layer - Tree layer
     * @param {Number} index - Index at layer.
     * @return {Buffer} - Node
     *
     *@example
     * ```js
     *const node = tree.getPairNode(layer, index)
     *```
     */

  }, {
    key: "_getPairNode",
    value: function _getPairNode(layer, idx) {
      var pairIdx = idx % 2 === 0 ? idx + 1 : idx - 1;

      if (pairIdx < layer.length) {
        return layer[pairIdx];
      } else {
        return null;
      }
    }
    /**
     * toTreeString
     * @desc Returns a visual representation of the merkle tree as a string.
     * @return {String}
     * @example
     *```js
     *console.log(tree.toTreeString())
     *```
     */

  }, {
    key: "_toTreeString",
    value: function _toTreeString() {
      var obj = this.getLayersAsObject();
      return treeify_1.default.asTree(obj, true);
    }
    /**
     * toString
     * @desc Returns a visual representation of the merkle tree as a string.
     * @example
     *```js
     *console.log(tree.toString())
     *```
     */

  }, {
    key: "toString",
    value: function toString() {
      return this._toTreeString();
    }
  }, {
    key: "isUnevenTree",
    value: function isUnevenTree(treeLayers) {
      var depth = (treeLayers === null || treeLayers === void 0 ? void 0 : treeLayers.length) || this.getDepth();
      return !this.isPowOf2(depth);
    }
  }, {
    key: "isPowOf2",
    value: function isPowOf2(v) {
      return v && !(v & v - 1);
    }
  }, {
    key: "calculateRootForUnevenTree",
    value: function calculateRootForUnevenTree(leafIndices, leafHashes, totalLeavesCount, proofHashes) {
      var leafTuples = this._zip(leafIndices, leafHashes).sort(function (_ref8, _ref9) {
        var _ref10 = _slicedToArray(_ref8, 1),
            indexA = _ref10[0];

        var _ref11 = _slicedToArray(_ref9, 1),
            indexB = _ref11[0];

        return indexA - indexB;
      });

      var leafTupleIndices = leafTuples.map(function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 1),
            index = _ref13[0];

        return index;
      });
      var proofIndices = this.getProofIndicesForUnevenTree(leafTupleIndices, totalLeavesCount);
      var nextSliceStart = 0;
      var proofTuplesByLayers = [];

      for (var i = 0; i < proofIndices.length; i++) {
        var indices = proofIndices[i];
        var sliceStart = nextSliceStart;
        nextSliceStart += indices.length;
        proofTuplesByLayers[i] = this._zip(indices, proofHashes.slice(sliceStart, nextSliceStart));
      }

      var tree = [leafTuples];

      for (var layerIndex = 0; layerIndex < proofTuplesByLayers.length; layerIndex++) {
        var currentLayer = proofTuplesByLayers[layerIndex].concat(tree[layerIndex]).sort(function (_ref14, _ref15) {
          var _ref16 = _slicedToArray(_ref14, 1),
              indexA = _ref16[0];

          var _ref17 = _slicedToArray(_ref15, 1),
              indexB = _ref17[0];

          return indexA - indexB;
        }).map(function (_ref18) {
          var _ref19 = _slicedToArray(_ref18, 2),
              hash = _ref19[1];

          return hash;
        });
        var s = tree[layerIndex].map(function (_ref20) {
          var _ref21 = _slicedToArray(_ref20, 1),
              layerIndex = _ref21[0];

          return layerIndex;
        });

        var parentIndices = _toConsumableArray(new Set(s.map(function (index) {
          if (index % 2 === 0) {
            return index / 2;
          }

          if (index % 2 === 0) {
            return (index + 1) / 2;
          }

          return (index - 1) / 2;
        })));

        var parentLayer = [];

        for (var _i2 = 0; _i2 < parentIndices.length; _i2++) {
          var parentNodeTreeIndex = parentIndices[_i2];
          var bufA = currentLayer[_i2 * 2];
          var bufB = currentLayer[_i2 * 2 + 1];
          var hash = bufB ? this.hashFn(Buffer.concat([bufA, bufB])) : bufA;
          parentLayer.push([parentNodeTreeIndex, hash]);
        }

        tree.push(parentLayer);
      }

      return tree[tree.length - 1][0][1];
    }
  }], [{
    key: "marshalLeaves",
    value: function marshalLeaves(leaves) {
      return JSON.stringify(leaves.map(function (leaf) {
        return MerkleTree.bufferToHex(leaf);
      }), null, 2);
    }
    /**
     * unmarshalLeaves
     * @desc Returns array of leaves of Merkle Tree as a Buffers.
     * @param {String|Object} - JSON stringified leaves
     * @return {Buffer[]} - Unmarshalled list of leaves
     * @example
     *```js
     *const leaves = MerkleTree.unmarshalLeaves(jsonStr)
     *```
     */

  }, {
    key: "unmarshalLeaves",
    value: function unmarshalLeaves(jsonStr) {
      var parsed = null;

      if (typeof jsonStr === 'string') {
        parsed = JSON.parse(jsonStr);
      } else if (jsonStr instanceof Object) {
        parsed = jsonStr;
      } else {
        throw new Error('Expected type of string or object');
      }

      if (!parsed) {
        return [];
      }

      if (!Array.isArray(parsed)) {
        throw new Error('Expected JSON string to be array');
      }

      return parsed.map(MerkleTree.bufferify);
    }
  }, {
    key: "marshalProof",
    value: function marshalProof(proof) {
      var json = proof.map(function (item) {
        if (typeof item === 'string') {
          return item;
        }

        if (Buffer.isBuffer(item)) {
          return MerkleTree.bufferToHex(item);
        }

        return {
          position: item.position,
          data: MerkleTree.bufferToHex(item.data)
        };
      });
      return JSON.stringify(json, null, 2);
    }
    /**
     * unmarshalProof
     * @desc Returns the proof for a target leaf as a list of Buffers.
     * @param {String|Object} - Merkle tree leaves
     * @return {String|Object} - Marshalled proof
     * @example
     * ```js
     *const proof = MerkleTree.unmarshalProof(jsonStr)
     *```
     */

  }, {
    key: "unmarshalProof",
    value: function unmarshalProof(jsonStr) {
      var parsed = null;

      if (typeof jsonStr === 'string') {
        parsed = JSON.parse(jsonStr);
      } else if (jsonStr instanceof Object) {
        parsed = jsonStr;
      } else {
        throw new Error('Expected type of string or object');
      }

      if (!parsed) {
        return [];
      }

      if (!Array.isArray(parsed)) {
        throw new Error('Expected JSON string to be array');
      }

      return parsed.map(function (item) {
        if (typeof item === 'string') {
          return MerkleTree.bufferify(item);
        } else if (item instanceof Object) {
          return {
            position: item.position,
            data: MerkleTree.bufferify(item.data)
          };
        } else {
          throw new Error('Expected item to be of type string or object');
        }
      });
    }
  }, {
    key: "verify",
    value: function verify(proof, targetNode, root) {
      var hashFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : sha256_1.default;
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var tree = new MerkleTree([], hashFn, options);
      return tree.verify(proof, targetNode, root);
    }
    /**
     * getMultiProof
     * @desc Returns the multiproof for given tree indices.
     * @param {Buffer[]} tree - Tree as a flat array.
     * @param {Number[]} indices - Tree indices.
     * @return {Buffer[]} - Multiproofs
     *
     *@example
     * ```js
     *const flatTree = tree.getLayersFlat()
     *const indices = [2, 5, 6]
     *const proof = MerkleTree.getMultiProof(flatTree, indices)
     *```
     */

  }, {
    key: "getMultiProof",
    value: function getMultiProof(tree, indices) {
      var t = new MerkleTree([]);
      return t.getMultiProof(tree, indices);
    }
  }]);

  return MerkleTree;
}(Base_1.default);

exports.MerkleTree = MerkleTree;

if (typeof window !== 'undefined') {
  ;
  window.MerkleTree = MerkleTree;
}

exports.default = MerkleTree;